"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DDBrowserTabbyAdapter = void 0;
const browser_logs_1 = require("@datadog/browser-logs");
exports.DDBrowserTabbyAdapter = {
    log: (severity, payload) => {
        const { message, error, tags, ...rest } = payload;
        switch (severity) {
            case "critical":
                return browser_logs_1.datadogLogs.logger.critical(message, { ...tags, ...rest }, error);
            case "error":
                return browser_logs_1.datadogLogs.logger.error(message, { ...tags, ...rest }, error);
            case "warn":
                return browser_logs_1.datadogLogs.logger.warn(message, { ...tags, ...rest }, error);
            case "info":
                return browser_logs_1.datadogLogs.logger.info(message, { ...tags, ...rest }, error);
            case "debug":
                return browser_logs_1.datadogLogs.logger.debug(message, { ...tags, ...rest }, error);
            case "trace":
                // The browser logger doesn't have a `trace` level, so we map to
                // `debug` instead. The only other option is `ok`, which is not an
                // appropriate level to map for `trace`.
                // By the way, manually passing in `status: trace` or `level: trace`
                // doesn't work either. It's still parsed in Datadog as `debug`.
                return browser_logs_1.datadogLogs.logger.debug(message, { ...tags, ...rest }, error);
        }
    },
    injectContext: (payload, _dependencies, traceContext) => {
        if (traceContext === null)
            return payload;
        return { ...payload, traceID: traceContext.traceID };
    },
    getTraceContextFromMetadata: metadata => metadata,
};
//# sourceMappingURL=dd_browser_adapter.js.map